import { lazy } from 'react'

const RELOAD_KEY = 'stealerhunt.chunk-reload'

export function isChunkLoadError(error) {
  const message = `${error?.name || ''} ${error?.message || error || ''}`
  return /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Failed to fetch/i.test(message)
}

function storage() {
  try { return window.sessionStorage } catch { return null }
}

/**
 * Recover open tabs after a deployment replaces their lazy-loaded chunks.
 *
 * A stale tab may keep the old main bundle in memory and only discover the
 * mismatch on its next route change. Reload once at the same URL so index.html
 * supplies the current bundle. The session marker prevents a broken network or
 * server from causing an infinite reload loop.
 */
export function lazyWithReload(importer) {
  return lazy(async () => {
    try {
      const module = await importer()
      storage()?.removeItem(RELOAD_KEY)
      return module
    } catch (error) {
      if (!isChunkLoadError(error)) throw error

      const store = storage()
      if (store?.getItem(RELOAD_KEY) !== '1') {
        store?.setItem(RELOAD_KEY, '1')
        window.location.reload()
        // Keep Suspense on screen until navigation replaces this document.
        return new Promise(() => {})
      }

      store?.removeItem(RELOAD_KEY)
      throw error
    }
  })
}
